import Swiper from 'swiper/bundle';
import 'swiper/css/bundle';

export const initSocialMediaScript = () => {
  const section = document.querySelector('.social-media');
  if (!section) return;

  section.querySelectorAll('.social-media__slide').forEach((slide) => {
    slide.classList.remove('lg:max-w-[308px]');
  });

  new Swiper('.social-media__container', {
    loop: false,
    setWrapperSize: true,
    slidesOffsetAfter: 0,
    watchOverflow: true,
    breakpoints: {
      340: { slidesPerView: 2.2129 },
      390: { slidesPerView: 3, spaceBetween: 12 },
      500: { slidesPerView: 4, spaceBetween: 12 },
      768: { slidesPerView: 2.48, spaceBetween: 12 },
      1024: { slidesPerView: 3 },
      1280: { slidesPerView: 4 },
      1536: { slidesPerView: 5 },
    },
  });
};
